import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'

import type { AdditioneleVraagResponse } from '../../klant/types/AdditioneleVraag'
import type { Produkt } from '../types/Produkt'

interface Props {
  product: Produkt
  beantwoordeVragen: AdditioneleVraagResponse[]
}

export const VraagAntwoord = ({ product, beantwoordeVragen }: Props) => {
  return (
    <TableRow sx={{ borderColor: 'white', border: '2px solid white' }}>
      <TableCell colSpan={6}>
        {beantwoordeVragen
          .filter((vraag) => vraag.disciplineID === product.disciplineID)
          .map((vraag) => {
            return (
              <Box key={`vraag-${vraag.disciplineID}-${product.netbeheerder}`}>
                <Typography
                  sx={{
                    pl: 5,
                    pb: 2,
                    color: 'rgb(61, 108, 180)',
                    fontFamily: '"Aller", "Helvetica", "sans-serif"',
                    fontSize: 24,
                    fontWeight: 200,
                    letterSpacing: '.02em',
                    lineHeight: '120%',
                    display: 'block',
                  }}
                >{`Beantwoorde vragen ${product.netbeheerder}`}</Typography>
                {vraag.additioneleVragen.map((v) => {
                  return (
                    <Grid
                      key={`vraag-add-${vraag.disciplineID}-${v.vraagCode}`}
                      sx={{ p: 1, pl: 5, width: '100%' }}
                      container
                      spacing={7}
                    >
                      <Grid size={{ xs: 8 }}>
                        <Typography sx={{ fontWeight: 'bold' }}>
                          {v.vraag}
                        </Typography>
                      </Grid>
                      <Grid size={{ xs: 4 }}>
                        <Typography>{v.antwoord}</Typography>
                      </Grid>
                    </Grid>
                  )
                })}
              </Box>
            )
          })}
      </TableCell>
    </TableRow>
  )
}
